import React, { useState, useEffect } from "react";
import { Drawer, Button, Skeleton, Row, Col } from "antd";
import { connect } from "react-redux";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
/* custom component */
import { ViewBox, ViewLabel, ViewValue } from "../../../component/Xcomponent";

/* action */
import {
  getPatientDetail,
  getPatientDetailReset,
} from "../../../action/getPatientDetailAction";
import { dateFormat } from "../../../utils";

const PatientView = (props) => {
  /* variable */
  const { getPatientDetail, getPatientDetailReset, getPatientDetailState } =
    props;

  /* callbacks */
  useEffect(() => {
    if (props.visible === false) {
      getPatientDetailReset();
    }
  }, [props.visible]);

  useEffect(() => {
    if (props.id && props.visible) {
      getPatientDetail({
        id: props.id,
      });
    }
  }, [props.id, props.visible]);

  return (
    <Drawer
      className="customWidthDrower"
      title={`Patient View`}
      placement="right"
      onClose={props.onClose}
      visible={props.visible}
      width={800}
    >
      {getPatientDetailState.apiState === "loading" && <Skeleton active />}

      {getPatientDetailState.apiState === "error" && (
        <p>{getPatientDetailState.message}</p>
      )}

      {getPatientDetailState.apiState === "success" && (
        <>
          <Row gutter={20}>
            <Col span="24">
              <h6>Personal Details</h6>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Name</ViewLabel>
                <ViewValue>
                  <span>
                    {getPatientDetailState.data.name.firstName}{" "}
                    {getPatientDetailState.data.name.lastName}
                  </span>
                </ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Gender</ViewLabel>
                <ViewValue>{getPatientDetailState.data.gender}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Phone</ViewLabel>
                <ViewValue>{getPatientDetailState.data.phone}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Email</ViewLabel>
                <ViewValue>{getPatientDetailState.data.email}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>DOB</ViewLabel>
                <ViewValue>
                  {dateFormat(getPatientDetailState.data.dob)}
                </ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Mother's Name</ViewLabel>
                <ViewValue>
                  {getPatientDetailState.data.mothersName?.firstName}{" "}
                  {getPatientDetailState.data.mothersName?.lastName}
                </ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Father's Name</ViewLabel>
                <ViewValue>
                  {getPatientDetailState.data.fathersName?.firstName}{" "}
                  {getPatientDetailState.data.fathersName?.lastName}
                </ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Husband's Or Father's Name</ViewLabel>
                <ViewValue>
                  {getPatientDetailState.data.husbandsOrFathersName}
                </ViewValue>
              </ViewBox>
            </Col>
            <Col span="24" className="mt-3">
              <h6>Address Details</h6>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Address</ViewLabel>
                <ViewValue>{getPatientDetailState.data.address}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>City</ViewLabel>
                <ViewValue>{getPatientDetailState.data.city}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>State</ViewLabel>
                <ViewValue>{getPatientDetailState.data.state}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Pincode</ViewLabel>
                <ViewValue>{getPatientDetailState.data.pinCode}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="24" className="mt-3">
              <h6>Other Details</h6>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Height</ViewLabel>
                <ViewValue>{getPatientDetailState.data.height}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Weight</ViewLabel>
                <ViewValue>{getPatientDetailState.data.weight}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Weeks</ViewLabel>
                <ViewValue>{getPatientDetailState.data.week}</ViewValue>
              </ViewBox>
            </Col>
            <Col span="12">
              <ViewBox>
                <ViewLabel>Interest</ViewLabel>
                <ViewValue>{getPatientDetailState.data.interest}</ViewValue>
              </ViewBox>
            </Col>
          </Row>
        </>
      )}
    </Drawer>
  );
};

const mapStateToProps = (state) => ({
  getPatientDetailState: state.getPatientDetail,
});

const mapDispatchToProps = (dispatch) => ({
  getPatientDetail: (params) => dispatch(getPatientDetail(params)),
  getPatientDetailReset: () => dispatch(getPatientDetailReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientView);
